import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {},
});

export default teamSlice.reducer;
export const {} = teamSlice.actions;
